// import store from '@/store'

export default {
  name: 'Login',
  path: '/login',
  // redirect: to => {
  // console.log('login redirect', store.getters['client/isLoggedIn'])
  // if (store.getters['client/isLoggedIn']) {
  //   return { name: 'Dashboard' }
  // } else {
  //   return false
  // }
  // },
  component: () =>
    import(
      /* webpackChunkName: "login" */
      '@/views/dashboard/Login/Index.vue'
    ),
}
